/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import Select from 'components/select';
import { sspSubmitOrder } from 'pages/provisioning/store/day2-operation';
import ProvisioningStyles from 'pages/provisioning/day2-operation/style';

const MaxShare = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(sspSubmitOrder);
    const [options, setOptions] = React.useState([]);
    const setMaxShare = (maxShare, maxShareDetail) => {
        setOrder({ ...order, maxShare, maxShareDetail });
    };
    const seldValueExistsInOptions = (maxShareValue) => options.find((option) => maxShareValue === option?.value);
    const handleOnSelectChange = (selected) => {
        if (seldValueExistsInOptions(selected?.value)) {
            setMaxShare(selected?.value, selected?.data);
        }
    };
    React.useEffect(() => {
        setOptions(['2', '5']?.map((data) => ({ label: data, value: data })));
    }, []);
    React.useEffect(() => {
        if (!order?.maxShare && order?.isTouched) setIsTouched(true);
    }, [order?.maxShare, order?.isTouched]);

    return (
        <Box sx={ProvisioningStyles.box}>
            <Select
                key="maxShare"
                label="Max Share *"
                value={order?.maxShare || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                isRequired={isTouched}
            />
        </Box>
    );
};

export default React.memo(MaxShare);
